import { render, staticRenderFns } from "./ReportsTab.vue?vue&type=template&id=b8013b9e&scoped=true&"
import script from "./ReportsTab.vue?vue&type=script&lang=js&"
export * from "./ReportsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8013b9e",
  null
  
)

export default component.exports